import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-service-strip',
  templateUrl: './customer-service-strip.component.html',
  styleUrl: './customer-service-strip.component.scss'
})
export class CustomerServiceStripComponent {

}
